import { SET_HEADER_LANGUAGE, SET_PLANT_NAME } from '../types';

export const setHeaderLanguage = (language) => ({
  type: SET_HEADER_LANGUAGE,
  payload: language,
});

export const setPlantName = (plantName) => ({
  type: SET_PLANT_NAME,
  payload: plantName,
});
